import { FormControl, Input, InputAdornment, OutlinedInput, TextField, Typography } from '@mui/material';
import { BaseInput } from 'components/forms/tags/BaseInput';
import React, { useEffect, useState } from 'react'

export function Timer({
    isActive,
}: {
    isActive: boolean
}) {
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        if (isActive) {
            setSeconds(0);
        }
    }, [isActive])

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;
    if (isActive) {
      interval = setInterval(() => {
        setSeconds(prevSeconds => prevSeconds + 1);
      }, 1000);
    } else if (!isActive && seconds !== 0) {
        if(interval){
            clearInterval(interval);
        }
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isActive, seconds]);

  return (
    <FormControl disabled variant="outlined">
        <OutlinedInput disabled
        value={seconds}
        endAdornment={<InputAdornment position="end">seconds</InputAdornment>}
        />
    </FormControl>
  );
}
